import useVendorTags from "../../hooks/useVendorTags";
import VendorTagsEditor from "./VendorTagsEditor";

/** VendorTagsEditor wired to the sponsor vendor-tags API. */
export default function VendorTagsEditorConnected({
  providerId,
  sponsorId = null,
  size = "sm",
  className = "",
}) {
  const { getTagListFor, addTag, removeTag, allKnownTags, isLoading } =
    useVendorTags(sponsorId);

  if (!providerId) return null;

  return (
    <VendorTagsEditor
      tags={getTagListFor(providerId)}
      allKnownTags={allKnownTags}
      onAddTag={(tag) => addTag(providerId, tag)}
      onRemoveTag={(tag) => removeTag(providerId, tag)}
      size={size}
      className={className}
      disabled={isLoading}
    />
  );
}
